import React, { useState } from 'react'
import { Input, Button, Modal } from 'semantic-ui-react'
import { PatternFormat } from 'react-number-format'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import 'moment/locale/pt-br'

import { ModalContentWrapper } from './styles'

interface OnChangeData {
  value: string
}

interface DateInputProps {
  name?: string
  value: string
  readOnly?: boolean
  minDate?: string | Date
  disabled?: boolean
  onChange?: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.SyntheticEvent<HTMLElement, Event>,
    data: OnChangeData
  ) => void
  onBlur?: (
    event:
      | React.FocusEvent<HTMLInputElement>
      | React.SyntheticEvent<HTMLElement, Event>,
    data: OnChangeData
  ) => void
}

export const DateInput: React.FC<DateInputProps> = ({
  name,
  value,
  readOnly,
  minDate,
  disabled,
  onChange,
  onBlur
}) => {
  const [modal, setModal] = useState(false)

  function handleModalClose() {
    setModal(false)
  }

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    onChange?.(event, { value: event.target.value })
  }

  function handlePickerChange(date: Date | null) {
    const formattedDate = date ? moment(date).format('DD/MM/YYYY') : ''
    onChange?.({} as React.SyntheticEvent<HTMLElement, Event>, {
      value: formattedDate
    })
    onBlur?.({} as React.SyntheticEvent<HTMLElement, Event>, {
      value: formattedDate
    })
    setModal(false)
  }

  function handleBlur(event: React.FocusEvent<HTMLInputElement>) {
    onBlur?.(event, { value: event.target.value })
  }

  const selectedDate = value ? moment(value, 'DD/MM/YYYY').toDate() : null

  return (
    <>
      <Input>
        <PatternFormat
          name={name}
          format="##/##/####"
          value={value}
          onChange={handleChange}
          readOnly={readOnly}
          disabled={disabled}
          onBlur={handleBlur}
        />
        <Button
          icon="calendar"
          type="button"
          onClick={() => setModal(true)}
          disabled={readOnly || disabled}
          basic
        />
      </Input>
      <Modal open={modal} onClose={handleModalClose} size="tiny" basic>
        <Modal.Content>
          <ModalContentWrapper>
            <DatePicker
              selected={selectedDate}
              onChange={handlePickerChange}
              dateFormat="dd/MM/yyyy"
              minDate={
                minDate instanceof Date
                  ? minDate
                  : minDate
                    ? new Date(minDate)
                    : undefined
              }
              inline
              locale="pt-br"
            />
          </ModalContentWrapper>
        </Modal.Content>
      </Modal>
    </>
  )
}
